import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Instagram, Facebook, Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const whatsappUrl = 'https://wa.me/919886332528';

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-column">
            <h3 className="footer-title">Dr. Manaz Physiotherapy</h3>
            <p className="footer-tagline">
              Panjim's Most Trusted Physiotherapy & Rehabilitation Clinic
            </p>
            <div className="footer-contact">
              <div className="contact-item">
                <Phone size={16} />
                <div>
                  <a href="tel:9886332528">9886332528</a>
                </div>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>House no, H-4, Miramar, Panaji, Goa 403001</span>
              </div>
              <div className="contact-item">
                <Clock size={16} />
                <span>Monday–Saturday: 9am–8pm<br />Sunday: Closed</span>
              </div>
            </div>
          </div>

          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/home-visit-physiotherapy-panjim">Home Visits</Link></li>
              <li><Link to="/our-team">Our Team</Link></li>
              <li><Link to="/equipment">Equipment</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/services/orthopaedic">Orthopaedic Physiotherapy</Link></li>
              <li><Link to="/services/sports-injury">Sports Injury Rehabilitation</Link></li>
              <li><Link to="/services/neurological">Neurological Physiotherapy</Link></li>
              <li><Link to="/services/post-surgical">Post-Surgical Rehabilitation</Link></li>
              <li><Link to="/services/paediatric">Paediatric Physiotherapy</Link></li>
              <li><Link to="/services/geriatric">Geriatric Care</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Connect With Us</h4>
            <div className="social-links">
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="mailto:info@drmanazphysio.com" aria-label="Email">
                <Mail size={20} />
              </a>
            </div>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="footer-cta">
              Book Appointment on WhatsApp
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {new Date().getFullYear()} Dr. Manaz's Physiotherapy & Rehabilitation Clinic. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;